import useDocumentTemplateTagContext from '../../../modules/documents/hooks/useDocumentTemplateTagContext';
import { FilterPickerConsumerProps } from './FilterPickerDynamicConsumer';

const DocumentTemplateTagFilterPickerConsumer: React.FC<
  FilterPickerConsumerProps
> = (props) => {
  //#region ------------------------------ Defaults
  const { children } = props;
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  const { data } = useDocumentTemplateTagContext();
  //#endregion

  //#region ------------------------------ Methods / Handlers
  //#endregion

  //#region ------------------------------ Effects
  //#endregion

  return (
    <>
      {children({
        options: data.map(({ documentTemplateTagId, name }) => {
          return {
            value: documentTemplateTagId,
            label: name,
            searchValue: name,
          };
        }),
      })}
    </>
  );
};

export default DocumentTemplateTagFilterPickerConsumer;
